import { WIDGET_COLORS } from '../constants/colors';

export function WidgetDivider() {
  return (
    <hr
      className="border-none h-px"
      style={{ backgroundColor: WIDGET_COLORS.divider, marginTop: '20px', marginBottom: '20px' }}
    />
  );
}
